import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faCircleExclamation,
    faEdit,
    faRectangleList,
    faCartShopping,
    faLineChart,
    faFileInvoiceDollar,
    faBars,
    faSort,
    faEye,
    faCalendarDays,
    faBroom,
    faPenSquare,
    faBoxOpen,
    faCentSign,
    faGhost,
    faAtom,
    faPalette,
    faEyeLowVision
} from '@fortawesome/free-solid-svg-icons';
import {faCircleCheck} from '@fortawesome/free-regular-svg-icons'
import Select from "../Utilities/Select";
import React, {useRef, useState} from "react";
import Modal from "../Utilities/Modal";
import CustomMultiSelect from "../Utilities/CustomMultiSelect";
import Accordion from "../Utilities/Accordion";
import Toman from "../Utilities/Toman";
import PriceChart from "../Utilities/PriceChart";
import {formatNumberWithDots, getDateAsReadableFormat} from "../../helper/general";
import ApiRoute from "../../helper/api";
import {toast} from "react-toastify";
import EditModel from "../Inventory/Modal/EditModal";
import PriceChartModel from "../Inventory/Modal/PriceChartModal";
import {Link} from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import PriceField from "../Common/PriceField";
import {hasAccess, HasAccessComponent} from "../../helper/permissions";
import PriceExpiredModel from '../Inventory/Modal/PriceExpiredModel';
import LogSidebar from '../Common/LogSidebar';
import PricingRulesModal from '../Common/PricingRulesModal';

function InventoryTable(props) {
    const MySwal = withReactContent(Swal)

    const tableTitles = [
        { title: 'شناسه'},
        {
            title: 'ش.آسان',
            sort:true,
            name:"asan_id"
        },
        {
            title: 'تایید',
            sort:true,
            name:"is_reviewable"
        },
        {
            title: 'ا.امروز',
            sort:true,
            name:"has_today_shipment"
        },
        { title: 'ارسال'},

        { title: 'رزرو',
          sort: true,
          name:"stocks_reservation"
        },
        {
            title: 'موجودی',
            sort: true,
            name:"stocks_web_site"
        },
        {
            title: 'م کل',
            sort:true,
            name:"total_stocks"
        },
        {
            title: 'عنوان',
            sort: true,
            name:"title"
        },
        /* { title: 'قیمت پیش', isPrice: true}, */
        { title: 'قیمت مرجع', isPrice: true},
        
        {
            title: '%.ق',
            sort: true,
            name:"price_percent"
        },
        {
            title: 'قیمت',
            isPrice: true,
            sort: true,
            name:"price"
        },
        {
            title: '',
            isPrice: false,
            sort: false,
            name:"price_expired"
        },
        {
            title: 'ویژه عادی',
            isPrice: true,
            sort: true,
            name:"regular_price"
        },
        {
            title: '%ق.و',
            sort: true,
            name:"regular_price_percent"
        },
        {
            title: 'قیمت ویژه',
            isPrice: true,
            sort: true,
            name:"sale_price"
        },
        {
            title: '%ف.ق',
            sort: true,
            name:"sale_price_percent"
        },
        {
            title: 'ق.اعتبار',
            isPrice: true,
            sort: true,
            name:"reward_credit_price"
        },
    ]
    const [isModalOpen, setIsModalOpen] = useState(null);
    const [modalData, setModalData] = useState(null);
    const openModal = (name,extraData = null) => {
        setModalData(extraData)
        setIsModalOpen(name)
    }
    const closeModal = () => setIsModalOpen(null)

    const [selectedId, setSelectedId] = useState([]);
    const [selectedSendMethod, setSelectedSendMethod] = useState([]);
    
    const [selectedPriceHistory, setSelectedPriceHistory] = useState(null);

    // new

    const [selectedItem , setSelectedItem] = useState({});
    const [isLogSidebarOpen, setIsLogSidebarOpen] = useState(false);
    const [selectedProductLogs, setSelectedProductLogs] = useState(null);
    const [isPricingRulesModalOpen, setIsPricingRulesModalOpen] = useState(false);
    const [selectedProductForPricing, setSelectedProductForPricing] = useState(null);
    const [pricingRules, setPricingRules] = useState(null);
    const [asanPurchasePrices, setAsanPurchasePrices] = useState({});
    const [asanPurchasePriceLoading, setAsanPurchasePriceLoading] = useState({});
    const [asanPurchasePriceErrors, setAsanPurchasePriceErrors] = useState({});
    const asanPurchasePriceRequests = useRef({});

    const getAsanPurchasePrice = async (productId) => {
        if (asanPurchasePriceRequests.current[productId]) {
            return;
        }

        asanPurchasePriceRequests.current[productId] = true;
        setAsanPurchasePriceLoading((current) => ({...current, [productId]: true}));
        setAsanPurchasePriceErrors((current) => ({...current, [productId]: null}));

        try {
            const response = await ApiRoute.product.inventory.asanPurchasePrice.fn(productId);
            const result = response?.results;

            if (response?.status_code === 200 && result?.asan_purchase !== undefined && result?.asan_purchase !== null) {
                setAsanPurchasePrices((current) => ({...current, [productId]: result}));
                return;
            }

            setAsanPurchasePriceErrors((current) => ({
                ...current,
                [productId]: response?.message || 'دریافت قیمت خرید آسان ناموفق بود.'
            }));
        } catch (error) {
            setAsanPurchasePriceErrors((current) => ({
                ...current,
                [productId]: 'دریافت قیمت خرید آسان ناموفق بود.'
            }));
        } finally {
            delete asanPurchasePriceRequests.current[productId];
            setAsanPurchasePriceLoading((current) => ({...current, [productId]: false}));
        }
    };

    const formatToman = (amount) => new Intl.NumberFormat('fa-IR').format(Number(amount));

    const getDisplayedAsanPurchasePrice = (product) => {
        if (asanPurchasePrices[product._id]) {
            return asanPurchasePrices[product._id];
        }

        if (product?.prices?.asan_purchase !== undefined && product?.prices?.asan_purchase !== null) {
            return {
                asan_purchase: product.prices.asan_purchase,
                synced_at: product?.metadata?.asan_purchase_synced_at
            };
        }

        return null;
    };

    const openLogSidebar = (product) => {
        setSelectedProductLogs(product);
        setIsLogSidebarOpen(true);
    };

    const closeLogSidebar = () => {
        setIsLogSidebarOpen(false);
        setSelectedProductLogs(null);
    };

    const openPricingRulesModal = async (product) => {
        const res = await ApiRoute.price.rule.getProductAsShopListRule.fn(product._id)
        if ( res?.status_code !== 200 ){
            return toast.error("خطای غیر منتظره")
        }
        setSelectedProductForPricing(product);
        setPricingRules(res.results);
        setIsPricingRulesModalOpen(true);
    };

    const closePricingRulesModal = () => {
        setIsPricingRulesModalOpen(false);
        setSelectedProductForPricing(null);
        setPricingRules(null);
    };

    function changeSelectedItem(value , name , tableData){
        setSelectedItem((current) => ({
            ...current,
            [tableData._id]: {
                ...current[tableData._id],
                [name]: value
            }
        }));
    }

    async function handleUpdate(id){

        const res = await ApiRoute.product.inventory.update.fn(id, {
            model:"\\App\\ProductManager\\Model\\ProductFull",
            fields: { ...selectedItem[id] },
            edited_by_inventory: true
        })

        //toast.success("بروزرسانی انجام شد")
    }
    // new

    const handleMultiSelectIds = (selectedId) => {
        setSelectedId(selectedId)
    }
    const handleMultiSelectSendMethods = (selectedSendMethod) => {
        setSelectedSendMethod(selectedSendMethod)
    }

    async function handleShowProductRule(product) {
        const res = await ApiRoute.price.rule.getProductRule.fn(product._id)
        if ( res?.status_code !== 200 ){
            return toast.error("خطای غیر منتظره")
        }
        let html = `<ul style="font-weight: bold;font-size: 20px;">`
        html += `<li class="flex mb-1 justify-between item-center gap-3"><div>سقف:</div><div>${res.results.ceil === undefined ? 'تعریف نشده' : res.results.ceil}</div></li>`
        html += `<li class="flex mb-1 justify-between item-center gap-3"><div>کف:</div><div>${res.results.floor === undefined ? 'تعریف نشده' : res.results.floor}</div></li>`
        html += `<li class="flex mb-1 justify-between item-center gap-3"><div>مرز حداکثر:</div><div>${res.results.max === undefined ? 'تعریف نشده' : res.results.max}</div></li>`
        html += `<li class="flex mb-1 justify-between item-center gap-3"><div>مرز حداقل:</div><div>${res.results.min === undefined ? 'تعریف نشده' : res.results.min}</div></li>`
        html += `<li class="flex justify-between item-center gap-3"><div>پیش فروش:</div><div>${res.results.presell === undefined ? 'تعریف نشده' : res.results.presell}</div></li>`
        html += `</ul>`

        const res_khn = await ApiRoute.price.rule.getProductRule.fn(product._id,{
            filter_shop_id: "6826568eafbf733b090ce162"
        })

        if ( res_khn?.status_code == 200 ){
            html += "<br><hr><br>"
            html += "<h3>خانگینو</h3>"
            html += `<ul style="font-weight: bold;font-size: 20px;">`
            html += `<li class="flex mb-1 justify-between item-center gap-3"><div>سقف:</div><div>${res_khn.results.ceil === undefined ? 'تعریف نشده' : res_khn.results.ceil}</div></li>`
            html += `<li class="flex mb-1 justify-between item-center gap-3"><div>کف:</div><div>${res_khn.results.floor === undefined ? 'تعریف نشده' : res_khn.results.floor}</div></li>`
            html += `<li class="flex mb-1 justify-between item-center gap-3"><div>مرز حداکثر:</div><div>${res_khn.results.max === undefined ? 'تعریف نشده' : res_khn.results.max}</div></li>`
            html += `<li class="flex mb-1 justify-between item-center gap-3"><div>مرز حداقل:</div><div>${res_khn.results.min === undefined ? 'تعریف نشده' : res_khn.results.min}</div></li>`
            html += `<li class="flex justify-between item-center gap-3"><div>پیش فروش:</div><div>${res_khn.results.presell === undefined ? 'تعریف نشده' : res_khn.results.presell}</div></li>`
            html += `</ul>`
        }

        MySwal.fire({
            title: `<p style="font-size: 20px;">قوانین ${product.title}</p>`,
            html: html,
            confirmButtonText: "متوجه شدم",
            cancelButtonText: `دست نگه دار`,
            showCancelButton: false,
        })
    }

    async function handlePriceHistory(product) {
        const res = await ApiRoute.product.priceHistory.fn(product._id)
        setSelectedPriceHistory(res.results)
        setIsModalOpen('changePrice')
    }

    function renderShippingLabels(tableData) {
        let shippingLabels = [];
        
        if (tableData?.categories?.includes('free-shipping')) {
            shippingLabels.push(
                <span key="free-shipping" className="bg-green-1 text-white rounded p-1 text-xs block mb-1">ارسال رایگان</span>
            );
        }
        
        if (tableData?.categories?.includes('free-shipping-tehran-and-karaj')) {
            shippingLabels.push(
                <span key="free-shipping-tehran-and-karaj" className="bg-green-1 text-white rounded p-1 text-xs block">ارسال رایگان تهران و البرز</span>
            );
        }
        
        return shippingLabels.length > 0 ? shippingLabels : null;
    }

    function getProductCampaigns(tableData) {
        return Array.isArray(tableData?.metadata?.campaigns)
            ? tableData.metadata.campaigns
            : [];
    }

    function renderCampaignLabel(tableData) {
        const campaigns = getProductCampaigns(tableData);

        if (campaigns.length === 0) {
            return null;
        }

        const className = "text-[#004D7F] mx-1 font-bold";

        return campaigns.map((campaign, index) => {
            const title = campaign?.title ?? 'کمپین';
            const key = campaign?.id ?? index;

            if (campaign?.id) {
                return (
                    <Link key={key} target='_blank' to={`/campaigns/edit?id=${campaign.id}`} className={className}>
                        ({title})
                    </Link>
                );
            }

            return <i key={key} className={className}>({title})</i>;
        });
    }

    return (
        <>
            <table className="table-auto w-full block mt-4">
                <thead>
                <tr className="border-b border-b-gray-7">
                    {tableTitles.map((item, id) => (
                        <td onClick={ () => {
                            if (item.sort !== true) return;
                            let dir = localStorage.getItem("sort_dir") ?? "desc";
                            if ( dir === "desc" ){
                                localStorage.setItem("sort_dir", "asc")
                            }else{
                                localStorage.setItem("sort_dir", "desc")
                            }
                            props.onSort(item.name , dir)
                        } } className={ (item.sort && 'cursor-pointer text-purple-1') +` text-13 relative text-gray-6 pb-2`} key={id}>
                            {item.title}
                            {item.sort && <FontAwesomeIcon className={`mr-2`} icon={faSort}/>}
                        </td>
                    ))}
                    <td></td>
                </tr>
                </thead>
                <tbody>
                {props.tableData?.map(tableData => (
                        <tr className={`text-xs py-2`} key={tableData?.id}>
                            <td className="!relative">
                                {tableData?.parent_id && <FontAwesomeIcon icon={faBoxOpen} className='text-blue-1 text-sm'/>}
                                <FontAwesomeIcon icon={faCircleCheck} className={parseInt(tableData?.product_id) > 0 ? 'text-green-1 text-sm' : 'text-red-1 text-sm'}/>
                            </td>
                            <td>
                                <input disabled={!hasAccess('asan_id inventory')} onChange={ (e) => {changeSelectedItem(e.target.value,'asan_id',tableData);} }
                                       type={`number`}
                                       defaultValue={tableData?.asan_id}
                                       className="border w-[70px] border-gray-7 rounded p-1"/>
                                <div className={`grid grid-cols-2 gap-1 w-[130px]`}>
                                    {Array.isArray(tableData.metadata.external_shops) && tableData.metadata.external_shops.map((shop, idx) => {
                                        let txt = "";
                                        if (shop.shop_name === "dgshahr") txt = "دیجیشهر";
                                        else if (shop.shop_name === "snapp") txt = "اسنپ شاپ";
                                        else if (shop.shop_name === "techno_life") txt = "تکنولایف";
                                        else if (shop.shop_name === "tapsi") txt = "تپسی";
                                        else return null;
                                        return <span title={!shop.is_active ? 'غیرفعال' : 'فعال'} key={shop.shop_name + idx} className={!shop.is_active ? 'bg-gray-7 rounded p-1 text-[red]' : 'bg-gray-7 rounded p-1' }>{txt}</span>;
                                    })}
                          
                                </div>
                            </td>
                            <td>
                                <Select
                                    disabled={!hasAccess('hold inventory')}
                                    onChange={ (v) => {
                                        changeSelectedItem(v,'is_reviewable',tableData)
                                    } }
                                    initialValue={tableData?.is_reviewable ? "true" : "false"}/>
                            </td>
                            <td>
                                <Select
                                    disabled={!hasAccess('shipment_day inventory')}
                                    onChange={ (v) => {
                                        changeSelectedItem(v,'has_today_shipment',tableData)
                                    } }
                                    initialValue={tableData?.has_today_shipment ? "true" : "false"}/>
                            </td>
                            <td className="min-w-[100px]">
                                {renderShippingLabels(tableData)}
                            </td>
                            {/*<td>
                                <Select onChange={ (v) => {
                                    changeSelectedItem(v,'has_presell',tableData)
                                } } initialValue={tableData?.has_presell ? "true" : "false"}/>
                            </td>
                            presell stock
                            <td><input disabled={!hasAccess(`presell_stock inventory`)} onChange={ (e) => {changeSelectedItem(e.target.value,'stocks_presell',tableData);} }
                                       type={`number`}
                                       defaultValue={tableData?.stocks.presell}
                                       className="border w-[50px] border-gray-7 rounded p-1"/></td>*/}

                            {/*reservation stock*/}
                            <td><span className="bg-gray-7 rounded p-1">{tableData?.stocks?.reservation ?? 0}</span></td>
                            {/*website stock*/}
                            <td><input
                                disabled={!hasAccess('stock inventory') || tableData?.parent_id}
                                onChange={ (e) => {changeSelectedItem(e.target.value,'stocks_web_site',tableData);} }
                                type={`number`}
                                defaultValue={tableData?.stocks.web_site} className="border w-[50px] border-gray-7 rounded p-1"/></td>
                            {/*total (asan) stock*/}
                            <td>
                                <div className={`grid grid-cols-2 gap-1 w-[150px]`}>
                                    <span className="bg-gray-7 rounded p-1">ایران  {tableData?.stocks?.iran ?? 0}</span>
                                    <span className="bg-gray-7 rounded p-1">پردیس  {tableData?.stocks?.kourosh ?? 0}</span>
                                    <span className="bg-gray-7 rounded p-1">فصلی  {tableData?.stocks?.franchise ?? 0}</span>
                                    <span className="bg-gray-7 rounded p-1">شرکت  {tableData?.stocks?.company ?? 0}</span>
                                </div>
                            </td>
                            {/*title*/}
                            <td className="min-w-[220px]">
                                <Link target='_blank' to={`/products/edit?product_id=${tableData._id}`}>{tableData?.title}</Link>
                                {tableData.status === "draft" ? ( <i>(پیشنویس)</i> ) : ''}
                                {tableData.status === "private" ? ( <i className="text-[#c750bf]"> (خصوصی) </i> ) : ''}
                                {renderCampaignLabel(tableData)}
                                <span className={tableData.stocks?.live < 1 ? `text-pink-1` : 'text-green-1'}><b> ({tableData.stocks?.live > 0 ? 'موجود' : 'ناموجود'}) </b></span>
                            </td>
                            {/*price*/}
                            {/*{<td>
                                tableData?.price_p?.percent > 0 ? (
                                    <div className="w-max mx-auto relative">
                                        <span className="bg-gray-7 rounded p-1">{tableData?.price_p?.price}</span>
                                        <span
                                            className="block text-right text-red-1 mt-1 absolute right-0 bottom-[-20px]">{tableData?.price_p?.percent}%</span>
                                    </div>
                                ) : (
                                    <div className="w-max mx-auto relative">
                                        <span className="border border-green-1 rounded p-1">{tableData?.price_p?.price}</span>
                                        <span
                                            className="block text-right text-green-1 mt-1 absolute right-0 bottom-[-20px]">{tableData?.price_p?.percent}%</span>
                                    </div>
                                )

                                }

                                <div className="w-max mx-auto relative">
                                    <PriceField disabled={!hasAccess(`presell_price inventory`)} className={`!w-[70px] !text-[11px]`} onChange={ (v) => {
                                        changeSelectedItem(v,'prices_presell',tableData);
                                    } } defaultValue={tableData?.prices?.presell}/>
                                </div>

                            </td>*/}

                            {/*reference price*/}
                            <td>
                                <div className="w-max mx-auto flex flex-col relative">
                                    <div className="flex items-center gap-1">
                                    <button  onClick={() => openPricingRulesModal(tableData)} className={(tableData?.metadata?.price_rule_id ? "btn-orange" : "btn-blue-light")+` py-1 max-w-max px-1 mt-1 text-[11px] flex items-center gap-1`}>
                                        <FontAwesomeIcon icon={faEye}/>
                                    </button>
                                    <PriceField disabled={!hasAccess('ref_price inventory')} className={`!w-[70px] !text-[11px]`} onChange={ (v) => {
                                        changeSelectedItem(v,'prices_reference',tableData);
                                    } } defaultValue={tableData?.prices?.reference}/>
                                    </div>
                                  
                                    
                                </div>

                            </td>
                            {/*extra percent*/}
                         {/*    <td>
                                <div className="w-max mx-auto flex flex-col relative">
                                    <div className="flex items-center gap-1">
                                    <input disabled={!hasAccess('ref_price inventory') || tableData?.shop_id !== "6735cfec475b2db6f30c51f2"} className={`!w-[70px] border border-[#ccc] rounded p-1 !text-[11px]`} onChange={ (v) => {
                                        changeSelectedItem(v.target.value,'reference_extra_percent',tableData);
                                    } } defaultValue={tableData?.metadata?.reference_extra_percent}/>
                                    </div>
                                  
                                    
                                </div>

                            </td> */}
                            {/* price percent */}
                            <td className={ (tableData?.metadata?.prices?.price?.percent > 0) ? `text-green-1` : 'text-red-1'} dir={`ltr`}>{tableData?.metadata?.prices?.price?.percent ?? 0}%</td>
                            {/* price */}
                            <td>
                                <div className="w-max mx-auto relative">
                                    {/*<FontAwesomeIcon className="text-yellow-1 text-xl absolute right-0 top-[-22px]" icon={faCircleExclamation}/>*/}
                                    <PriceField disabled={!hasAccess('price inventory') || tableData?.metadata?.reference_extra_percent > 0} className={`!w-[70px] !text-[11px]`} onChange={ (v) => {
                                        changeSelectedItem(v,'prices_price',tableData);
                                    } } defaultValue={tableData?.prices?.price ?? 0}/>

                                </div>
                                <div>{tableData?.metadata?.pass_gateway_price === true && 'تک قیمتی'}</div>
                                <div>اسنپ : {formatNumberWithDots(tableData?.prices?.snapp_pay ?? 0)}</div>
                                <div>اسنپ پی اعتباری : {formatNumberWithDots(tableData?.prices?.snapp_pay_financing ?? 0)}</div>
                                <div>تارا : {formatNumberWithDots(tableData?.prices?.tara ?? 0)}</div>
                            </td>
                            {/* price expired */}
                            <td>
                                {tableData.price_expired == 1 ? <FontAwesomeIcon onClick={ () => { openModal('priceExpired',tableData) } } title='قیمت منقضی شده' icon={faCircleExclamation} className="text-orange-2 cursor-pointer mt-1 text-sm"/> : ''}
                            </td>
                            {/* price regular */}
                            <td>
                                <PriceField disabled={!hasAccess('regular_price inventory')} className={`!w-[70px] !text-[11px]`} onChange={ (v) => {
                                    changeSelectedItem(v,'prices_regular',tableData);
                                } } defaultValue={tableData?.prices?.regular ?? 0}/>
                                <HasAccessComponent permission="asan_purchase_price inventory">
                                {(() => {
                                    const asanPurchasePrice = getDisplayedAsanPurchasePrice(tableData);

                                    return (
                                <div className="mt-1 w-max max-w-[150px]">
                                    <button
                                        type="button"
                                        onClick={() => getAsanPurchasePrice(tableData._id)}
                                        disabled={asanPurchasePriceLoading[tableData._id]}
                                        className="border border-gray-7 bg-gray-1 text-gray-5 rounded px-1.5 py-1 text-[10px] leading-none hover:bg-gray-7 disabled:cursor-not-allowed disabled:opacity-60"
                                    >
                                        {asanPurchasePriceLoading[tableData._id] ? 'در حال استعلام...' : 'دریافت'}
                                    </button>
                                    {asanPurchasePrice && (
                                        <div className="mt-1 text-[10px] text-gray-5 leading-4">
                                            <div className="font-medium text-gray-6">
                                                {formatToman(asanPurchasePrice.asan_purchase)} تومان
                                            </div>
                                            {asanPurchasePrice.synced_at && (
                                                <div className="text-[9px] text-gray-5">
                                                   {getDateAsReadableFormat(asanPurchasePrice.synced_at, true)}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {asanPurchasePriceErrors[tableData._id] && (
                                        <div className="mt-1 text-[10px] leading-4 text-red-1">
                                            {asanPurchasePriceErrors[tableData._id]}
                                        </div>
                                    )}
                                </div>
                                    );
                                })()}
                                </HasAccessComponent>
                            </td>
                            {/* price regular percent */}
                            <td className={ (tableData?.metadata?.prices?.regular?.percent > 0) ? `text-green-1` : 'text-red-1'} dir={`ltr`}>{tableData?.metadata?.prices?.regular?.percent ?? 0}%</td>
                            {/* price sale */}
                            <td>
                                <PriceField 
                                    disabled={!hasAccess('sale_price inventory')}
                                    className={`!w-[70px] !text-[11px]`} 
                                    onChange={(v) => {
                                        changeSelectedItem(v,'prices_sale',tableData);
                                    }} 
                                    defaultValue={tableData?.prices?.sale ?? 0}
                                />
                            </td>
                            {/* price percent sale */}
                            <td className={ (tableData?.metadata?.prices?.sale?.percent > 0) ? `text-green-1` : 'text-red-1'} dir={`ltr`}>{tableData?.metadata?.prices?.sale?.percent ?? 0}%</td>
                            {/* reward credit price */}
                            <td>
                                {(() => {
                                    const rewardCreditPercent = selectedItem[tableData._id]?.prices_reward_credit_percent
                                        ?? tableData?.metadata?.prices?.reward_credit?.percent
                                        ?? '';
                                    const isRewardCreditPriceReadOnly = rewardCreditPercent !== ''
                                        && rewardCreditPercent !== null
                                        && rewardCreditPercent !== undefined
                                        && Number(rewardCreditPercent) !== 0;

                                    return (
                                        <>
                                            <label className="block mb-1 text-[10px] text-gray-5">درصد</label>
                                            <PriceField
                                                className={`!w-[70px] !text-[11px]`}
                                                onChange={(v) => {
                                                    changeSelectedItem(v,'prices_reward_credit_percent',tableData);
                                                }}
                                                defaultValue={tableData?.metadata?.prices?.reward_credit?.percent ?? ''}
                                            />
                                            <PriceField
                                                readOnly={isRewardCreditPriceReadOnly}
                                                className={`!w-[70px] !text-[11px] mt-1 ${isRewardCreditPriceReadOnly ? '!bg-gray-7' : ''}`}
                                                onChange={(v) => {
                                                    changeSelectedItem(v,'prices_reward_credit',tableData);
                                                }}
                                                defaultValue={tableData?.prices?.reward_credit ?? 0}
                                            />
                                        </>
                                    );
                                })()}

                            </td>
                            <td>

                                <div className="flex gap-1">

                                    <button onClick={ async () => { await handleUpdate(tableData._id) }} title="بروزرسانی"><FontAwesomeIcon
                                        className="bg-green-1 text-white p-1 w-4 h-4 rounded" icon={faEdit}/></button>

                                    <button title="اطلاعات اضافی" onClick={() => {
                                        openModal('moreDetail',tableData)
                                    }}><FontAwesomeIcon
                                        className="bg-blue-1 text-white p-1 w-4 h-4 rounded" icon={faRectangleList}/>
                                    </button>

                                    <HasAccessComponent permission={`price_chart inventory`} children={<button title="نمودار تغییرات قیمت" onClick={() => openModal('priceChart',tableData)}>
                                        <FontAwesomeIcon
                                            className="bg-red-1 text-white p-1 w-4 h-4 rounded"
                                            icon={faLineChart}/></button>}/>

                                    <button title="10 تغییر اخیر قیمت ها" onClick={() => handlePriceHistory(tableData)}>
                                        <FontAwesomeIcon
                                            className="bg-orange-1 text-white p-1 w-4 h-4 rounded"
                                            icon={faFileInvoiceDollar}/></button>

                                    <Link to={`/orders?product_id=${tableData.id}&product_title=${tableData.title}`} title="سفارشات"><FontAwesomeIcon
                                        className="bg-yellow-1 text-white p-1 w-4 h-4 rounded" icon={faCartShopping}/></Link>
                                    <Link to={`/reservations?product_id=${tableData._id}`} title="رزرو ها"><FontAwesomeIcon
                                        className="bg-purple-4 text-white p-1 w-4 h-4 rounded" icon={faCalendarDays}/></Link>

                                    <HasAccessComponent permission={`log inventory`} children={<button onClick={ () => {
                                        openLogSidebar(tableData);
                                    } } title="مشاهده لاگ‌ها"><FontAwesomeIcon
                                        className="bg-gray-5 text-white p-1 w-4 h-4 rounded" icon={faBars}/></button>}/>

                                </div>
                            </td>
                        </tr>
                    )
                )}
                </tbody>
            </table>

            { (isModalOpen && isModalOpen === 'moreDetail') && <EditModel product={modalData} closeModal={ () => {
                closeModal()
            } }/>}
            { (isModalOpen && isModalOpen === 'priceChart') && <PriceChartModel product={modalData} closeModal={ () => {
                closeModal()
            } }/>}

            { (isModalOpen && isModalOpen === 'priceExpired') && <PriceExpiredModel onSuccess={()=>{
                props.setUpdateData(Date.now())
            }} product={modalData} closeModal={ () => {
                closeModal()
            } }/>}

            <Modal isOpen={isModalOpen && isModalOpen === 'changePrice'} onClose={closeModal}
                   modalWidth="2xl:w-1/4 h-auto scrollbar-style dir-rtl">
                <div className="page-title z-1 mb-3 text-13"><span className="inline-block bg-white pl-3 z-2 relative">10 تغییر اخیر قیمت ها</span>
                </div>
                <div className="border border-gray-7 rounded-md p-3 text-xs">

          
                        <Accordion arrowIcon={true} customClsses="shadow-style px-4">

                        {selectedPriceHistory && Object.entries(selectedPriceHistory).map((item, index) => (
                        <div>
                        <div className="flex p-3">
                            <div>
                                {item[1].reset_expired_price == true ? <FontAwesomeIcon title='قیمت ریست شده' icon={faCircleExclamation} className="text-orange-2 cursor-pointer ml-1 text-sm"/> : ''}
                                <span className="text-gray-12 ml-1">تاریخ و ساعت:</span>
                                <span className="text-gray-5">{getDateAsReadableFormat(item[0],true)}</span>
                            </div>
                        </div>
                        <div className="pb-3">
                            <table className="table-auto rounded-md w-full box-shadow-bottom">
                                <thead>
                                <tr className="">
                                    <td className="text-right px-4 py-2 w-1/3 bg-gray-7 rounded-tr-md">نوع</td>
                                    <td className="text-center px-4 py-2 w-1/3 bg-gray-7">توسط</td>
                                    <td className="text-left px-4 py-2 w-1/3 bg-gray-7 rounded-tl-md">
                                        <div className="flex items-center justify-end">
                                            قیمت
                                            <Toman/>
                                        </div>
                                    </td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr className="shadow-none">
                                    <td className="text-right w-1/3 border-b border-b-gray-7">قیمت اصلی</td>
                                    <td className="text-center w-1/3 border-b border-b-gray-7">{item[1].employee_name}</td>
                                    <td className="text-left w-1/3 border-b border-b-gray-7">{item[1].price}</td>
                                </tr>
                                <tr className="shadow-none border-b border-b-gray-7">
                                    <td className="text-right w-1/3 border-b border-b-gray-7">قیمت ویژه عادی</td>
                                    <td className="text-center w-1/3 border-b border-b-gray-7">{item[1].employee_name ?? '-'}</td>
                                    <td className="text-left w-1/3 border-b border-b-gray-7">{item[1].regular ?? '-'}</td>
                                </tr>
                                <tr className="shadow-none border-b border-b-gray-7">
                                    <td className="text-right w-1/3 border-b border-b-gray-7">قیمت ویژه فوری</td>
                                    <td className="text-center w-1/3 border-b border-b-gray-7">{item[1].employee_name ?? '-'}</td>
                                    <td className="text-left w-1/3 border-b border-b-gray-7">{item[1].sale}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    ))}

                            
                       
                        
                       
                    </Accordion>
                </div>
            </Modal>

            {/* کامپوننت سایدبار لاگ‌ها */}
            <LogSidebar 
                isOpen={isLogSidebarOpen}
                onClose={closeLogSidebar}
                selectedProduct={selectedProductLogs}
            />

            {/* مودال قوانین قیمت‌گذاری */}
            <PricingRulesModal
                isOpen={isPricingRulesModalOpen}
                onClose={closePricingRulesModal}
                productData={selectedProductForPricing}
                pricingRules={pricingRules} // می‌تواند از API دریافت شود
                otherStoresPrices={null} // می‌تواند از API دریافت شود
            />

        </>
    )
}

export default InventoryTable
